exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "ol li.teams-pagination-details{border:1px solid #33373a;padding:5px 10px;font-size:14px;font-weight:400}ol li.teams-pagination-details:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px}ol li.teams-pagination-details:last-child{border-top-right-radius:4px;border-bottom-right-radius:4px}ol li.teams-pagination-details:hover{cursor:pointer;font-weight:800;background-color:#eee}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/app/components/teamdetails/teamdetails.css
// module id = 565
// module chunks = 0